module.exports = __webpack_public_path__ + "static/media/strengths.e9b92e8c.png";